import style from './Header.module.css';
import Button from '../UI/Button';
import MockUp from '../images/image-mockups.png';

const Header =()=>{

    return( 
    <header className={style.header}>
        <div className={style.headerImgContainer}>
            <img src={MockUp} alt=""/>
        </div>

        <div className={style.headerInfoContainer}>
            <h1 className={style.title}>Next generation digital banking</h1>
            <p className={style.paragraph}>
                Take your financial life online.
                 Your Easybank account will be a one-stop-shop for 
                 spending, saving, budgeting, investing, and much more.
            </p>
            <Button></Button>
        </div>
        


    </header>
        )

}

export default Header;